export interface GroupsRepartitionData {
    current: GroupsRepartitionProperties;
    versus: GroupsRepartitionProperties;
    comparison: Pick<GroupsRepartitionProperties, 'nbGroups'>;
}

export type GroupsRepartitionProperties = {
    nbGroups: number;
    averageGroups: number;
    nbGroupsByLevel: Record<string, number>;
};
